import { render } from "./FigureCard.vue?vue&type=template&id=2e9ab9a5&scoped=true"
import script from "./FigureCard.vue?vue&type=script&lang=js"
export * from "./FigureCard.vue?vue&type=script&lang=js"

import "./FigureCard.vue?vue&type=style&index=0&id=2e9ab9a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9ab9a5"]])

export default __exports__